"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),a=require("styled-components"),i=require("@vds/typography"),t=require("@vds/buttons"),n=require("@plans/type-lockups"),o=require("@vds-tokens/core"),r=require("@plans/utilities"),s=require("@vds/utilities");function d(e){return e&&e.__esModule?e:{default:e}}var l=d(a);const c=e=>{let a="?";const i=Object.keys(e);return i.forEach(((t,n)=>{const o=n+1>=i.length;a+=`${t}=${e[t]}${o?"":"&"}`})),a},p=l.default.div.withConfig({displayName:"ComponentWrapper",componentId:"VDS__sc-16inl47-0"})`
  background-color: ${({surface:e})=>o.ColorTokens.background.primary[`${e}`].value};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (min-width: ${r.breakpoints.desktop.min}) {
    aspect-ratio: 3/1;
    background-image: ${({backgroundImage:e,imageVariant:a})=>(e||a)&&`url(${e}3x1-${a||"default"}${c(e.queryParams||{resMode:"sharp",scl:"1"})})`};
  }

  @media (min-width: ${r.breakpoints.tabletSmall.min}) and (max-width: ${r.breakpoints.tabletLarge.max}) {
    aspect-ratio: 9/4;
    background-image: ${({backgroundImage:e,imageVariant:a})=>(e||a)&&`url(${e}9x4-${a||"default"}?${c(e.queryParams||{resMode:"sharp",scl:"1"})})`};
  }

  @media (min-width: ${r.breakpoints.mobileLarge.min}) and (max-width: ${r.breakpoints.mobileLarge.max}) {
    aspect-ratio: 1/1;
    background-image: ${({backgroundImage:e,imageVariant:a})=>(e||a)&&`url(${e}1x1-${a||"default"}${c(e.queryParams||{resMode:"sharp",scl:"1"})})`};
  }

  @media (max-width: ${r.breakpoints.mobileSmall.max}) {
    aspect-ratio: 1/1;
    background-image: ${({backgroundImage:e,imageVariant:a})=>(e||a)&&`url(${e}1x1-${a||"pdp"}${c(e.queryParams||{resMode:"sharp",scl:"1"})})`};
  }
`,m=l.default.div.withConfig({displayName:"ContentContainer",componentId:"VDS__sc-16inl47-1"})`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  width: 100%;
  @media (min-width: ${r.breakpoints.desktop.min}) {
    max-width: ${r.breakpoints.desktop.max};
    margin: 0px auto;
    padding: ${o.LayoutTokens.space["12X"].value}
      ${o.LayoutTokens.space["5X"].value};
  }

  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding: ${o.LayoutTokens.space["12X"].value}
      ${o.LayoutTokens.space["5X"].value};
  }
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    padding: ${o.LayoutTokens.space["8X"].value} ${o.LayoutTokens.space["4X"].value};
  }
`,u=l.default.div.withConfig({displayName:"TopContainer",componentId:"VDS__sc-16inl47-2"})`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    flex-direction: row;
  }
`,g=l.default.div.withConfig({displayName:"BottomContainer",componentId:"VDS__sc-16inl47-3"})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`,b=l.default.div.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-16inl47-4"})`
  overflow: hidden;
  text-overflow: ellipsis ellipsis;
  white-space: wrap;
  ${({width:e})=>e&&`\n    width: 100%;\n    max-width: ${e};\n  `}
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding-bottom: ${o.LayoutTokens.space["8X"].value};
  }
`,h=l.default.div.withConfig({displayName:"ButtonWrapper",componentId:"VDS__sc-16inl47-5"})`
  width: auto;
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    padding-left: ${o.LayoutTokens.space["4X"].value};
  }
`,f=l.default.div.withConfig({displayName:"LogoWrapper",componentId:"VDS__sc-16inl47-6"})`
  align-self: end;
`,x=l.default.div.withConfig({displayName:"PricingWrapper",componentId:"VDS__sc-16inl47-7"})`
  align-self: flex-end;
  padding-left: ${o.LayoutTokens.space["12X"].value};
  width: auto;
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    padding-left: ${o.LayoutTokens.space["3X"].value};
  }
`,k=l.default.img.withConfig({displayName:"Logo",componentId:"VDS__sc-16inl47-8"})`
  height: 56px;
  object-fit: contain;
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    height: 40px;
  }
`,$=l.default.div.withConfig({displayName:"FirstPriceWrapper",componentId:"VDS__sc-16inl47-9"})`
  padding-bottom: ${({showBottomPadding:e})=>e?o.LayoutTokens.space["2X"].value:"0px"};
`;var w=s.withVDSManager((a=>{const{title:r,buttonGroup:s,oldPrice:d,newPrice:l,image:c,backgroundImage:w,surface:y="light",elementSurface:v="light",viewport:j}=a,L="tabletLarge"===j||"tablet"===j;return e.jsx(p,Object.assign({backgroundImage:(()=>{switch(typeof w){case"string":return w;case"object":return`${null==w?void 0:w.baseUrl}${null==w?void 0:w.perkName}-`;default:return null}})(),imageVariant:"object"==typeof w?w.variant:void 0,surface:y},{children:e.jsxs(m,{children:[e.jsxs(u,{children:[e.jsx(b,Object.assign({width:null==r?void 0:r.width},{children:e.jsx(i.Title,Object.assign({color:o.ColorTokens.elements.primary[`on${v}`].value},r,{size:L?"large":"XLarge"}))})),e.jsx(h,{children:s&&e.jsx(t.ButtonGroup,Object.assign({surface:v},s))})]}),e.jsxs(g,{children:[e.jsx(f,{children:e.jsx(k,Object.assign({},c))}),e.jsxs(x,{children:[l&&e.jsx($,Object.assign({showBottomPadding:"desktop"===j},{children:e.jsx(n.Pricing,Object.assign({},l,{size:"desktop"===j?"2XLarge":"XLarge",surface:v,color:"primary"}))})),d&&e.jsx(n.Pricing,Object.assign({},d,{size:"small",color:"primary",surface:v,alignment:"right"}))]})]})]})}))}),!0);exports.default=w;
